import login from 'html/login/login.html';
import changeAccount from 'html/login/change-account.html';
import App from 'app/app.js';
import 'app/store/UserProfileStore.js';

import 'app/store/ContentStore.js';
import 'app/service/RouterService.js';
import 'app/service/TranslateProviderService.js';
import 'app/service/ValidationService.js';
import 'app/service/BlockService.js';
import 'app/service/StatsdService.js';

var LOGIN_PATH = '/login',
  CHANGE_ACCOUNT_PATH = '/switch-account',
  LOGIN_ROUTE_CONFIG = {
    template: login,
    controller: 'LoginCtrl',
    controllerAs: 'login',
    jobRequired: false,
    orderRequired: false,
    orderFlow: false
  },
  CHANGE_ACCOUNT_ROUTE_CONFIG = {
    template: changeAccount,
    controller: 'LoginCtrl',
    controllerAs: 'login',
    jobRequired: false,
    orderRequired: false,
    orderFlow: false
  },
  RouteProviderConfig = function ($routeProvider) {
    $routeProvider.when(LOGIN_PATH, LOGIN_ROUTE_CONFIG);
    $routeProvider.when(CHANGE_ACCOUNT_PATH, CHANGE_ACCOUNT_ROUTE_CONFIG);
  };

function LoginCtrl(
  UserProfileStore,
  OrderFormService,
  TranslateProviderService,
  RouterService,
  ContentStore,
  ValidationService,
  $scope,
  $location,
  BlockService,
  $window,
  $q,
  IdentityService,
  StorageService,
  $filter,
  AnalyticsService,
  StatsdService,
  $timeout,
  EmailValidationService
) {
  this.canadianDomain = TranslateProviderService.isCanadianDomain();
  this.isChangeAccount = false;
  this.email = '';
  this.studentIdNewClaimForm = $scope.studentIdNewClaimForm;
  this.optInEmailEnabled = window.optInEmailEnabled;
  this.createAccountFromPopup = false;
  this.emailInvalid = false;

  this.getFormId = function () {
    // if we're coming from the banner page this will only be the student id
    // the load event for the lifetouch code is located on a different controller
    var fromBannerPage = $scope.fromBannerPage && AnalyticsService.ADOBE_FORM_IDS.ADD_NEW_STUDENT_ID;
    var fromNewForm = this.studentIdNewClaimForm
      ? AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_STUDENTID
      : AnalyticsService.ADOBE_FORM_IDS.LOGIN_SHUTTERFLY_ACCOUNT;
    return fromBannerPage || fromNewForm;
  };

  this.init = function () {
    var path = $location.path();
    const newAccountEmail = StorageService.getData('unregisteredEmail');
    if (!this.isLoggedIn() && !!$scope.email) {
      this.email = $scope.email;
    } else if (newAccountEmail) {
      this.email = newAccountEmail;
      StorageService.remove('unregisteredEmail');
    }
    if (this.isLoggedIn() && $scope.studentIdSignInFlow !== true) {
      return RouterService.goToMyAccount();
    }

    if (path === CHANGE_ACCOUNT_PATH) {
      this.isChangeAccount = true;
      this.email = UserProfileStore.userProfile.email || StorageService.getData('identityEmail');
    } else if (!!UserProfileStore.guestUserProfile.email) {
      this.email = UserProfileStore.guestUserProfile.email;
    }

    if (this.isChangeAccount && !this.email) {
      return RouterService.goToLogin();
    }

    AnalyticsService.addAdobeFormLoadEvent(this.getFormId());

    if ($window.ltSsoConfig.identityEnabled) {
      if (!$scope.isInModal) {
        BlockService.blockUI();
      }
      IdentityService.resyncIdentity().finally(
        function () {
          if (!$scope.isInModal) {
            BlockService.unblockUI();
          }
          if (this.isLoggedIn() && $scope.studentIdSignInFlow !== true) {
            RouterService.goToMyAccount();
          }
        }.bind(this)
      );
    }
    const isEmailSmartUrl =
      (path.startsWith('/pictureDayId') || path.startsWith('/accessCredentials') || path.startsWith('/saved-cart')) &&
      path.includes('/email');

    const isSavedCart = path.startsWith('/saved-cart');

    if (!isEmailSmartUrl && !isSavedCart) {
      this.triggerContinueAsGuest();
    } else if (isEmailSmartUrl) {
      $timeout(() => {
        this.continue();
      }, 0);
    }
  };

  this.triggerContinueAsGuest = function () {
    var path = $location.path();
    if (RouterService.isSmartUrl(path)) {
      this.continueAsGuest();
    }
  };

  this.getPopoverText = function () {
    var popOverContent = ContentStore.getContent(null, ContentStore.appendCountryCode('STD_ID_DESC_POPOVER_CONTENT'));
    var learnMoreText = ContentStore.getContent(null, ContentStore.appendCountryCode('STD_ID_LEARN_MORE'));

    return '<div class="pop-content">' + popOverContent + learnMoreText + '</div>';
  };

  this.getEmailOptInLabel = function () {
    return ContentStore.getContent(null, ContentStore.appendCountryCode('CREATE_ACCOUNT_EMAIL_OPTIN'));
  };

  this.resetErrors = function (field) {
    ValidationService.resetErrors(field);
    this.emailInvalid = false;
  };

  this.goToLogin = function () {
    RouterService.goToLogin();
  };

  this.continueAsGuest = function () {
    var path = $location.path();

    if (path.startsWith('/accessCredentials')) {
      OrderFormService.changeFlowToPortraitId();
    } else if (path.startsWith('/studentId')) {
      OrderFormService.changeFlowToStudentId();
    } else {
      OrderFormService.changeFlowToLifetouchCode();
    }
  };

  this.isInvalid = function () {
    ValidationService.validateEmail($scope.form.email, 6, 64);
    return $scope.form.$invalid;
  };

  this.continue = function () {
    let path = $location.path();
    if (this.isInvalid()) {
      AnalyticsService.addAdobeFormErrorEvent(
        this.getFormId(),
        AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.INVALID_EMAIL
      );
      if (path.includes('/email')) {
        this.storeEmail();
        RouterService.goToHome();
      }
      return;
    }
    EmailValidationService.validateEmail(this.email).then((response) => {
      if (response && !response.success) {
        this.emailInvalid = true;
        $scope.form.email.$error.emailFormat = true;
        return;
      }

      AnalyticsService.addAdobeFormSuccessEvent(this.getFormId());

      if ($scope.studentIdSignInFlow === true) {
        RouterService.pushLocationIfNotLastVisited(LOGIN_PATH);
      }

      BlockService.blockUI();
      var identityPromise;
      if ($window.ltSsoConfig.identityEnabled) {
        identityPromise = IdentityService.isEmailIdentityEligible(this.email);
      } else {
        identityPromise = $q.resolve(false);
      }

      var identityEligible;
      identityPromise
        .then(
          function (result) {
            identityEligible = result;
          },
          function () {
            identityEligible = false;
          }
        )
        .then(
          function () {
            return UserProfileStore.userProfileStatus(this.email);
          }.bind(this)
        )
        .then(
          function () {
            switch (UserProfileStore.getUserType()) {
              case 'NEW':
                if (path.includes('/email')) {
                  StorageService.setData('unregisteredEmail', this.email);
                  RouterService.goToHome();
                } else {
                  this.createAccount(identityEligible);
                }
                break;
              case 'GUEST':
                this.guestRecovery(identityEligible);
                break;
              case 'LOYALTY':
              case 'NONLOYALTY':
                this.enterPassword(identityEligible);
                break;
              default:
                StatsdService.incrementCounter('UNKNOWN_USER_TYPE');
            }
          }.bind(this)
        )
        .finally(function () {
          BlockService.unblockUI();
        });
    });
  };

  this.loginIdentity = function (redirectPath) {
    if (!redirectPath) {
      redirectPath = RouterService.getPathBeforeLogin();
    }
    this.storeEmail();
    const redirectUrl = RouterService.getSPAPath() + `?userType=${UserProfileStore.getUserType()}` + '#' + redirectPath;
    const changeAccountUrl = RouterService.getSPAPath() + '#' + RouterService.paths.CHANGE_ACCOUNT;
    return IdentityService.loginIdentity(this.email, redirectUrl, changeAccountUrl);
  };

  this.createAccount = function (identityEligible) {
    StorageService.set('createAccountFromPopup', this.createAccountFromPopup);
    if (identityEligible) {
      this.loginIdentity();
      RouterService.redirectAfterAccountCreation();
    } else {
      RouterService.goToCreateAccount();
    }
  };

  this.enterPassword = function (identityEligible) {
    if (identityEligible) {
      this.loginIdentity();
    } else {
      RouterService.goToEnterPassword();
    }
  };

  this.guestRecovery = function (identityEligible) {
    if (identityEligible) {
      this.loginIdentity();
      RouterService.redirectAfterAccountCreation();
    } else {
      RouterService.goToWelcomeBack();
    }
  };

  this.isLoggedIn = function () {
    return UserProfileStore.isLoggedIn();
  };

  this.getLoginRedirectUrl = function () {
    if (TranslateProviderService.isCanadianDomain()) {
      return ContentStore.getContent('MOBILE_TRANS_LOGIN', 'SIGN_IN_SWITCH_TO_US_URL');
    } else {
      return ContentStore.getContent('MOBILE_TRANS_LOGIN', 'SIGN_IN_SWITCH_TO_CANADA_URL');
    }
  };

  this.storeEmail = function () {
    StorageService.setData('identityEmail', this.email);
  };

  this.getSignInAccountDisclaimerKey = function () {
    var domain = this.canadianDomain ? 'CA' : 'US';
    return 'SIGN_IN_ACCOUNT_LEGAL_' + domain;
  };

  this.goToIDontHaveCode = function () {
    $scope.onCancel();
    RouterService.goToIDontHaveCode();
  };

  this.getPopover = function () {
    var pictureDayText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PICTURE_DAY_ID_TEXT')
    );
    var pictureDayImage = ContentStore.getContentImageUrl(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PICTURE_DAY_ID_IMAGE')
    );
    var pictureDayAlt = ContentStore.getContent('MOBILE_TRANS_HOME', 'POPOVER_PICTURE_DAY_ID_IMAGE_ALT');

    var portraitIdText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_TEXT')
    );
    var portraitIdImage = ContentStore.getContentImageUrl(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_IMAGE')
    );
    var portraitIdAlt = ContentStore.getContent('MOBILE_TRANS_HOME', 'POPOVER_PORTRAIT_ID_IMAGE_ALT');

    return (
      '' +
      '<div class="digital-info-popover">' +
      '<p class="mara-dark-grey f5 text-center">' +
      pictureDayText +
      '</p>' +
      '   <div><img src="' +
      pictureDayImage +
      '" alt="' +
      pictureDayAlt +
      '"/></div>' +
      '   <p class="f5 mara-dark-grey text-center top-24">' +
      portraitIdText +
      '</p>' +
      '   <div><img src="' +
      portraitIdImage +
      '" alt="' +
      portraitIdAlt +
      '"/></div>' +
      '</div>'
    );
  };
}

App.controller('LoginCtrl', [
  'UserProfileStore',
  'OrderFormService',
  'TranslateProviderService',
  'RouterService',
  'ContentStore',
  'ValidationService',
  '$scope',
  '$location',
  'BlockService',
  '$window',
  '$q',
  'IdentityService',
  'StorageService',
  '$filter',
  'AnalyticsService',
  'StatsdService',
  '$timeout',
  'EmailValidationService',
  LoginCtrl
]);

App.config(['$routeProvider', RouteProviderConfig]);

App.run([
  'RouterService',
  function (RouterService) {
    RouterService.paths.LOGIN = LOGIN_PATH;
    RouterService.goToLogin = RouterService.goTo(LOGIN_PATH);

    RouterService.paths.CHANGE_ACCOUNT = CHANGE_ACCOUNT_PATH;
    RouterService.goToChangeAccount = RouterService.goTo(CHANGE_ACCOUNT_PATH);
  }
]);
